import { useSnackbar } from 'notistack';
import React, { useState } from 'react';
import { useMutation, useQueryClient } from 'react-query';
import { useParams } from 'react-router-dom';
import * as api from '../../api/app/plannedQtyDeviationApi';
import { PlannedQtyDeviationCreateRequest } from '../../types/app/plannedQtyDeviation.types';
import { SubmitHandler } from 'react-hook-form';
import { convertDataFromInputToCreateRequest } from '../../utils/core/functions/plannedQtyDeviation.functions';
import { PlannedQtyDeviationForm } from './PlannedQtyDeviationForm';
import { AssetDashboardSetting } from '../../types/app/asset.types';
import { AllowedTime } from '../../types/app/plannedQty.types';
import moment, { Moment } from 'moment';
import { convertTimeStampToMinutes } from '../../utils/core/functions/convertDateTime';
import { utcFormat } from '../../types/core/date.types';
import { Timezone } from '../../components/app/TimezoneChanger/TimezoneChanger';
import { useTranslation } from '../../contexts/translation';
interface Props {
  onClose: any;
  settingData: AssetDashboardSetting;
  dateFrom: Moment | null;
  timezone: Timezone;
}
export function PlannedQtyDeviationCreate({ onClose, settingData, dateFrom, timezone }: Props) {
  const queryClient = useQueryClient();
  const { t } = useTranslation();
  const { id } = useParams();
  const { enqueueSnackbar } = useSnackbar();
  const [selectedTime, setSelectedTime] = useState<AllowedTime>();

  const { mutate: mutateCreatePlannedQtyDeviation } = useMutation(api.createPlannedQtyDeviation);

  const handleOnSubmitCreate: SubmitHandler<PlannedQtyDeviationCreateRequest> = (
    data: PlannedQtyDeviationCreateRequest,
  ) => {
    const timeEndInterval = selectedTime!.time.split(' - ')[1];
    const requestData = convertDataFromInputToCreateRequest({
      ...data,
      assetId: Number(id),
      time:
        timeEndInterval === '00:00'
          ? moment(dateFrom).startOf('day').add(1, 'day').utc().format(utcFormat)
          : moment(dateFrom)
              .startOf('day')
              .utc()
              .add(convertTimeStampToMinutes(timeEndInterval), 'minutes')
              .format(utcFormat),
    });

    mutateCreatePlannedQtyDeviation(
      { ...requestData },
      {
        onSuccess: () => {
          enqueueSnackbar(t('page.dashboard.planned-qty-deviation.item-created'), {
            variant: 'success',
          });
          queryClient.invalidateQueries(['plannedQtyDeviation']);
          onClose();
        },
        onError: (result: any) => {
          enqueueSnackbar(`${result}`, { variant: 'error' });
        },
      },
    );
  };

  return (
    <PlannedQtyDeviationForm
      onSubmit={handleOnSubmitCreate}
      onBack={onClose}
      settingData={settingData}
      setSelectedTime={setSelectedTime}
      timezone={timezone}
    />
  );
}
